var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon Container"},React.createElement("path",{"id":"Union","d":"M9.4498 17.55C9.3498 17.55 9.25814 17.5334 9.1748 17.5C9.09147 17.4667 9.00814 17.4084 8.9248 17.325L4.3998 12.8C4.2498 12.65 4.1748 12.4667 4.1748 12.25C4.1748 12.0334 4.2498 11.85 4.3998 11.7C4.5498 11.55 4.7248 11.475 4.9248 11.475C5.1248 11.475 5.2998 11.55 5.4498 11.7L9.4498 15.7L18.5248 6.62502C18.6748 6.47502 18.854 6.40002 19.0623 6.40002C19.2706 6.40002 19.4498 6.47502 19.5998 6.62502C19.7498 6.77502 19.8248 6.95419 19.8248 7.16252C19.8248 7.37086 19.7498 7.55002 19.5998 7.70002L9.9748 17.325C9.89147 17.4084 9.80814 17.4667 9.7248 17.5C9.64147 17.5334 9.5498 17.55 9.4498 17.55Z","fill":"#2B271F"})));
}

Checkmark.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
